export default {
	allGlobalAddresses: [],
	errors: {
		invalidName: false,
		invalidPostalCode: false
	},
	loading: {
		fetchAllGlobalAddresses: false,
	},
};
